import React, { useState } from "react";
import { updatePayoutById } from "../../../../../store/actions/payout";
import styles from "../styles.module.css";
import { toast } from "react-toastify";

const UpdateStatusModal = ({
  data,
  payouts,
  setPaymentStatusModal,
  setPayouts,
}) => {

  const [status, setStatus] = useState(data?.status || data?.paymentStatus || "Pending");

  const handleClick = async () => {
    const result = await updatePayoutById(data?._id, {
      status: status,
      paymentStatus: status, // Keep both for safety
    });

    if (result.success) {
      toast.success("Payout updated successfully");

      const index = payouts.findIndex((el) => el._id === data._id);
      if (index !== -1) {
        // Create a copy to trigger re-render properly if needed
        const updatedPayouts = [...payouts];
        updatedPayouts[index] = result.data;
        setPayouts(updatedPayouts);
      }

      setPaymentStatusModal(false);
    } else {
      toast.error("Something went wrong! Please try again later.");
    }
  };

  const handleChange = (e) => {
    setStatus(e.target.value);
  };

  return (
    <div className={styles.modalBackdrop}>
      <div
        className={styles.modal}
        style={{ width: "500px" }}>
        <div className={styles.modal_header}>
          <h1>Update Status</h1>
          <i
            className={styles.closeBtn + " fas fa-close"}
            onClick={() => {
              setPaymentStatusModal(false);
            }}></i>
        </div>

        <div
          className={styles.modal_body}
          style={{ marginTop: "1rem" }}>
          <p style={{ marginBottom: "1.5rem", color: "#64748b", fontSize: "0.95rem" }}>
            Select the new processing status for this payout request.
          </p>

          <div className={styles.radio_input}>
            <input
              type='radio'
              name='status'
              value='Initiated'
              id="status-initiated"
              checked={status === "Initiated"}
              onChange={handleChange}
            />
            <label htmlFor="status-initiated" style={{ cursor: "pointer", fontWeight: "600", flex: 1 }}>Initiated</label>
          </div>
          <div className={styles.radio_input}>
            <input
              type='radio'
              name='status'
              value='In Progress'
              id="status-progress"
              checked={status === "In Progress"}
              onChange={handleChange}
            />
            <label htmlFor="status-progress" style={{ cursor: "pointer", fontWeight: "600", flex: 1 }}>In Progress</label>
          </div>
          <div className={styles.radio_input}>
            <input
              type='radio'
              name='status'
              value='Completed'
              id="status-completed"
              checked={status === "Completed"}
              onChange={handleChange}
            />
            <label htmlFor="status-completed" style={{ cursor: "pointer", fontWeight: "600", flex: 1 }}>Completed</label>
          </div>

          <div className={styles.radio_input}>
            <input
              type='radio'
              name='status'
              value='Rejected'
              id="status-rejected"
              checked={status === "Rejected"}
              onChange={handleChange}
            />
            <label htmlFor="status-rejected" style={{ cursor: "pointer", fontWeight: "600", flex: 1 }}>Rejected</label>
          </div>
        </div>

        <div style={{ marginTop: "2rem" }}>
          <button
            onClick={handleClick}
            className={styles.submitBtn}>
            Update Status
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateStatusModal;
